(function(){
    angular.module('Directives')
    .directive('progressIndicator', progressIndicator);

    function progressIndicator() {
        return {
            restrict: 'E',
            scope: {
                progressData: '='
            },
            templateUrl: '/templates/directives/progress-indicator.html',
            link: progressIndicatorLink
        }

        function progressIndicatorLink($scope) {
            $scope.cssData = {'width' : `${$scope.progressData}%`}
            $scope.$watch('progressData', (n)=>{
                $scope.cssData = {'width' : `${n}%`}
            });
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/progress-indicator.js